module.exports = __webpack_public_path__ + "static/prevent-errors-5adc1ed545da2771faede9f365f7c7e9.png";